export const Container = ({ children }) => {
    return <div className="flex flex-wrap gap-4 px-4 mt-8">{children}</div>;
};
